"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var get = require('../getValueOfKeyMatching');

function weddingPostponementAnnouncements(params) {
  var quantity = parseInt(get(params, /announcements/), 10);
  var guest_addressing = parseBoolean(get(params, /inv_guestAddressing/));
  var return_addressing = parseBoolean(get(params, /inv_returnAddressing/));
  var response_cards = parseInt(get(params, /responseCards/), 10);
  var response_return_addressing = parseBoolean(get(params, /response_returnAddressing/));
  var small_enclosures = parseInt(get(params, /smallEnclosures/), 10);
  this.announcements.add({
    quantity: quantity
  });
  this.invitationEnvelopes.add({
    quantity: quantity,
    return_addressing: return_addressing,
    guest_addressing: guest_addressing
  });

  if (response_cards) {
    this.responseCards.add({
      quantity: response_cards
    });
    this.responseCardEnvelopes.add({
      quantity: response_cards,
      return_addressing: response_return_addressing
    });
  }

  if (small_enclosures) {
    this.smallEnclosures.add({
      quantity: small_enclosures
    });
  }

  var linerParam = get(params, /liner/);
  var has_liner = parseBoolean(linerParam) || !!linerParam.match(/floral|classic/i);

  if (has_liner || params.product_type.match(/floral/i)) {
    this.envelopeLiners.add({
      quantity: quantity,
      liner_pattern: get(params, /floral-liner-pers|classic-liner-pers|liner-grid-pers/),
      liner_color: get(params, /classic-liner-color-pers|liner-color-grid-pers/)
    });
  }

  this.personalization.push({
    name: 'Announcement Personalization',
    // eslint-disable-next-line
    value: params.pers_announcements
  });

  if (return_addressing) {
    this.personalization.push({
      name: 'Return Address',
      value: params.pers_inv_returnAddressing
    });
  }

  if (response_cards) {
    this.personalization.push({
      name: 'Response Cards',
      value: params.pers_responseCards
    });
  }

  if (response_return_addressing) {
    this.personalization.push({
      name: 'Response Return Address',
      value: params.pers_response_returnAddressing
    });
  }

  if (small_enclosures) {
    this.personalization.push({
      name: 'Small Enclosures',
      value: params.pers_smallEnclosures
    });
  }
}

module.exports = weddingPostponementAnnouncements;